import {
  CreateMessageRequest,
  DeleteMessageRequest,
  ViewMessageOverviewRequest,
  ViewMessagesRequest
} from './support.types';

import { API_HOST, HttpGetOptions, HttpPostOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/support`;

export const getViewMessageOverviewRequest = (requestData: ViewMessageOverviewRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/message-overview/${requestData.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewMessagesRequest = (requestData: ViewMessagesRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/view/message/${requestData.programmeExternalReference}/${requestData.systemUserExternalReference}/${
    requestData.page
  }/${requestData.size}`,
  getHttpGetOptions()
];

export const getCreateMessageRequest = (
  requestData: CreateMessageRequest
): [string, HttpPostOptions<CreateMessageRequest>] => [getEndpoint(), getHttpPostOptions(requestData)];

export const getDeleteMessageRequest = (requestData: DeleteMessageRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/delete/message/${requestData.programmeExternalReference}/${
    requestData.systemUserExternalReference
  }`,
  getHttpGetOptions()
];
